import styled from 'styled-components';
import { Form } from 'antd';

export const FormS = styled(Form)`
  padding: 15px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 2px 9px rgba(0, 0, 0, 0.0801191);
  border-radius: 4px;
  margin-bottom: 19px;
`;




// WEBPACK FOOTER //
// ./src/modals/add-meeting-notes-modal/task-form/styled-components.js